import React, { ReactElement } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, Container, useScrollTrigger } from '@mui/material';

// project imports
import MenuList from './MenuList';
import useConfig from 'shared/hooks/useConfig';
import { APP_HEADER_OFFSET_PX, HORIZONTAL_MENU_BAR_HEIGHT_PX } from 'constant';

// ==============================|| HORIZONTAL MENU LIST ||============================== //

interface ElevationScrollProps {
    children: ReactElement;
    window?: Window | Node;
}

function ElevationScroll({ children, window }: ElevationScrollProps) {
    const theme = useTheme();
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window!
    });

    theme.shadows[4] = theme.customShadows.z1;

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0
    });
}

// ==============================|| HORIZONTAL MENU LIST ||============================== //

const CustomAppBar = () => {
    const theme = useTheme();

    const { container } = useConfig();

    return (
        <ElevationScroll>
            <AppBar
                sx={{
                    top: APP_HEADER_OFFSET_PX,
                    bgcolor: theme.palette.background.paper,
                    color: theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.text.primary,
                    width: '100%',
                    height: HORIZONTAL_MENU_BAR_HEIGHT_PX,
                    justifyContent: 'center',
                    // App.jsx T.borderLight — line under header + above horizontal strip
                    borderTop: theme.palette.mode === 'light' ? '1px solid #F0EDEA' : `1px solid ${theme.palette.divider}`,
                    borderBottom: theme.palette.mode === 'light' ? '1px solid #F0EDEA' : `1px solid ${theme.palette.divider}`,
                    backgroundImage: 'none',
                    zIndex: 1098
                }}
            >
                <Container maxWidth={container ? 'lg' : false}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <MenuList />
                    </Box>
                </Container>
            </AppBar>
        </ElevationScroll>
    );
};

export default CustomAppBar;
